import { parseTags } from '~/utils/tags';
import { IAlertModel } from '../model';

export default (self: IAlertModel) => {
  function alertStatusFilterTags() {
    const tags: string[] = [self.statusType()];
    return tags.map((tag) => tag.toLowerCase());
  }
  return {
    get alertStatusFilterTags() {
      return alertStatusFilterTags();
    },
    get tagsFilterTags() {
      return parseTags(self.description);
    },
    get filterTags() {
      return [...self.alertStatusFilterTags, ...self.tagsFilterTags];
    },
    get searchString() {
      const { name, description } = self;
      return [name, description].join(' ').toLowerCase();
    }
  };
};
